import { CART_PAGE_NAME, CART_PAGE_SECTION, CART_PAGE_STAGE } from './cartui';

// Sets version used by TrackingJS component.
// Note: Be sure the @vp/react-tracking version in package.json supports the version here.
export const TRACKING_LIB_VERSION = '9';

// PayPal Message offer types and corresponding message variant
export const PAYPAL_OFFERTYPE_BELOW_30 = 'GPLNQ';
export const PAYPAL_OFFERTYPE_BETWEEN_30_AND_200 = 'GPLQ';
export const PAYPAL_OFFERTYPE_ABOVE_200 = 'LT_MQGZ';
export const PAYPAL_MESSAGE_VARIANT_BELOW_30 = 'Amount below $30';
export const PAYPAL_MESSAGE_VARIANT_BETWEEN_30_AND_200 =
  'Amount between $30 and $200';
export const PAYPAL_MESSAGE_VARIANT_ABOVE_200 = 'Amount more than $200';

export const CART_STEP_VIEWED_HEADER = {
  step: 1, // checkout cart step
  label: 'Cart View', // checkout step name
  pageSection: CART_PAGE_SECTION,
  pageStage: CART_PAGE_STAGE,
  pageName: CART_PAGE_NAME,
};

export const CHECKOUT_STEP_VIEWED_EVENT_NAME = 'Checkout Step Viewed';
